import { LoadingController } from '@ionic/angular';
import { Injectable } from '@angular/core';

import { SettingsProvider } from '../settings/settings';
import { AlertProvider } from '../alert/alert';
import * as moment from 'moment';
import { HelperProvider } from '../helper/helper';
import { LoadingProvider } from '../loading/loading';
import { Router } from '@angular/router';

import { SharedDataProvider } from '../shared-data/shared-data';
import { HttpHeaders } from '@angular/common/http';
const qs = require('qs');
const axios = require('axios').default;

let baskClient = axios.create({
  // baseURL: 'http://127.0.0.1:3333/api/v1/',
  // baseURL: 'https://dashboard.basketaki.com/api/v1/',
  baseURL: 'https://mbl4on4.com/wp-json/sportspress/v2/',
});

@Injectable()
export class BasketakiRestProvider {
  loadings = [];
  constructor(
    public sharedData: SharedDataProvider,
    public settings: SettingsProvider,
    public helper: HelperProvider,
    public loadingController: LoadingController,
    public loadingProv: LoadingProvider,
    public alertprov: AlertProvider
  ) {
    let that = this;
    baskClient.interceptors.request.use(
      async function (config) {
        // await that.refreshToken()
        let loading = await that.loadingController.create({
          message: 'Παρακαλώ Περιμένετε...',
        });
        await loading.present();
        that.loadings.push({
          url: config.url,
          loading: loading,
        });
        // config.headers['AppVersion'] = await helper.getAppVersion();
        //config.headers['Authorization'] = 'Bearer ' + (await this.getToken());

        return config;
      },
      function (error) {
        console.error(error);
        return Promise.reject(error);
      }
    );
    baskClient.interceptors.response.use(
      function (response) {
        // console.log('got response');
        let url = response.config.url.replace(response.config.baseURL, '');
        let loading = that.loadings.find((l) => l.url == url);
        let ind = that.loadings.indexOf(loading);
        loading.loading.dismiss();
        that.loadings.splice(ind, 1);
        return response.data;
      },
      async function (error) {
        // console.log('got error');
        // console.log(error);

        //handles hide loading
        let url = error.config.url.replace(error.config.baseURL, '');
        let loading = that.loadings.find((l) => l.url == url);
        let ind = that.loadings.indexOf(loading);
        loading.loading.dismiss();
        that.loadings.splice(ind, 1);

        switch (error.response.status) {
          case 400:
            // TODO: may if critical
            that.alertprov.showError(error.response.data.message);
            break;
          case 401:
            console.error('un-authorised user...');

            let originalRequest = error.config;
            if (!originalRequest._retry) {
              console.error('refreshing token...');
              originalRequest._retry = true;
              await that.refreshToken();
              // axios.defaults.headers.common['Authorization'] = 'Bearer ' + await this.getToken()
              let tkn = await that.getToken();
              // console.log(tkn);
              originalRequest.headers.common['Authorization'] = 'Bearer ' + tkn;
              return baskClient(originalRequest);
            } else {
              that.alertprov.showError(
                'Αδυναμία ταυτοποίησης χρήστη.Παρακαλώ προσπαθήστε ξανά.'
              );
            }
            // that.sharedData.logOut()
            break;
          case 500:
            that.alertprov.showError('Εσωτερικό σφάλμα εξυπηρετητή.');
            break;
          default:
            break;
        }
        return Promise.reject(error.response.data);
      }
    );
  }

  async GetGameList(date) {
    let formattedDate = moment(date).format('YYYY-MM-DD');
    return baskClient.get(
      'events?after=' +
        formattedDate +
        'T00:00:00&before=' +
        formattedDate +
        'T23:59:59&per_page=100'
    );
  }

  async GetTeam(teamId) {
    return baskClient.get('teams/' + teamId + '?_fields=id,title,slug,lists');
  }
  async GetTeamRosters(teamId) {
    let team = await this.GetTeam(teamId);
    console.log('Team:', team);
    let rosters = [];

    for (let i = 0; i < team.lists.length; i++) {
      let roster = await baskClient.get('lists/' + team.lists[i]);
      roster.teamName = team.title.rendered
        .replaceAll('&#8217;', "'")
        .replaceAll('&#038;', '&');
      rosters.push(roster);
    }

    return rosters;
  }

  async refreshToken() {
    let refresh = await baskClient.post(
      'refresh',
      {
        refresh_token: await this.settings.get('refresh_token'),
      },
      {}
    );
    // console.log(refresh);
    await this.settings.set('access_token', refresh.access_token);
    await this.settings.set('refresh_token', refresh.refresh_token);
    // await this.settings.set("isLogged", true)
    // await this.helper.openStartPage()
  }
  async login(Email, Password) {
    let login = await baskClient.post(
      'login',
      {
        email: Email,
        password: Password,
      },
      {}
    );
    // console.log(login);
    await this.settings.set('access_token', login.token);
    await this.settings.set('refresh_token', login.refreshToken);
    await this.settings.set('isLogged', true);
    this.sharedData.isLogged = true;
  }
  async register(Email, Password, Password2) {
    let register = await baskClient.post(
      'register',
      {
        email: Email,
        password: Password,
        password_retype: Password2,
      },
      {}
    );
  }
  async logOut() {
    // console.log('logging out user ....');
    await this.settings.set('access_token', '');
    await this.settings.set('refresh_token', '');
    await this.settings.set('isLogged', false);
    this.sharedData.isLogged = false;

    await this.helper.openStartPage();
  }
  async getToken() {
    return this.settings.get('access_token');
  }
  async addStatistic(
    event_id,
    team_id,
    player_id,
    period,
    minute,
    second,
    locPerX,
    locPerY,
    type,
    points
  ) {
    return baskClient.post(
      'stat',
      {
        event_id: event_id,
        team_id: team_id,
        player_id: player_id,
        period: period,
        minute: minute,
        second: second,
        locPerX: locPerX,
        locPerY: locPerY,
        type: type,
        points: points,
      },
      {
        headers: {
          Authorization: 'Bearer ' + (await this.getToken()),
        },
      }
    );
  }
  async rosters() {
    return baskClient.get('rosters');
  }
  async players(rosterId) {
    return baskClient.get('roster/' + rosterId + '/players');
  }
  async games(date) {
    return baskClient.post(
      'stats-games',
      {
        date: date,
      },
      {}
    );
  }
  async syncData(game) {
    return baskClient.post(
      'sync-stats',
      {
        game: game,
      },
      {}
    );
  }

  async getTeam(id, fields: Array<string> = []) {
    return baskClient.get(
      'teams/' + id + '?_fields=' + fields + '&_embed=true'
    );
  }
}
